

















































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import * as rules from "@/rules"
import { API, Storage } from 'aws-amplify';
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";


const viewpointModule = getModule(Viewpoints)
const decisionsModule = getModule(Decisions)
const choicesModule = getModule(Choices)

@Component({
    components: {}
})
export default class FeedbackForm extends Vue {
    private readonly RULES = rules;
    private readonly TYPES = [
        {
            type: 'GENERAL',
            display: "General Feedback"
        },
        {
            type: 'ISSUE',
            display: "Report a Bug"
        }
    ]

    private readonly IMAGE_RULES = [
        (value: any) => !value || value.size < 4000000 || 'Screenshot size should be less than 4 MB!',
    ]

    private open = false;
    private submitting = false;
    private submitted = false;
    private feedbackForm: Feedback = {type: 'ISSUE', page: 'admin-tool'};

    @Ref()
    private form: HTMLFormElement;

    @Watch('open')
    private onOpenChange() {
        this.feedbackForm = {type: 'ISSUE', page: 'admin-tool'};
        this.submitted = false;
    }

    private async submit() {
        if (!this.form.validate()) return;

        this.submitting = true;
        let imageKey = null;
        if (this.feedbackForm.type === 'ISSUE' && this.feedbackForm.image) {
            let key = 'feedback/' + this.feedbackForm.image.name;
            let uploadResponse: any = await Storage.put(key, this.feedbackForm.image);
            imageKey = uploadResponse.key
        }

        let body = this.feedbackForm.body + this.getDebugInformation();

        let myInit = {
            body: Object.assign(JSON.parse(JSON.stringify(this.feedbackForm)), {body: body, image: imageKey})
        }
        await API.post('Viewpoint360API', '/feedback', myInit)

        this.submitting = false;
        this.submitted = true;
        this.form.reset();
    }

    private getDebugInformation(): string {
        return "\n\n====================\nDEBUG INFORMATION\n====================\n" +
            "\nPath: " + this.$router.currentRoute.path +
            "\nDecision: " + decisionsModule.selectedDecisionId +
            "\nViewpoints: " + viewpointModule.selectedViewpointIds +
            "\nChoice: " + choicesModule.selectedChoiceId
    }

}

interface Feedback {
    type: string,
    subject?: string,
    body?: string,
    image?: File,
    rating?: number,
    page?: string
}
